
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ArticleDto } from "../../dtos/articleDto";
import { ArticleState } from "../../dtos/articleState";
import httpClient from "../../store/httpClient";
import ArticleCadPreview from "@/components/ArticleCadPreview.vue";
import ArticleFaceTypes from "@/dtos/IArticleFaceTypes";
import { IArticleFaceType } from "@/dtos/IArticleFaceTypes";
import PowderFinishes from "@/dtos/IPowderFinish";
import { IPowderFinish } from "@/dtos/IPowderFinish";
import PowderStructures from "@/dtos/IPowderStructure";
import { IPowderStructure } from "@/dtos/IPowderStructure";
import { getEntgratartText } from "@/dtos/entgratart";
import UpdateBoundingBoxCommand from "./UpdateBoundingBoxCommand.vue";
import { ArticleHelper } from "@/views/Article/ArticleHelper";
import PricelistButtonComponent from "./PricelistButtonComponent.vue";
import { PriceListDto } from "@/dtos/priceListDto";
import { ValidationStepState } from "@/dtos/validationStepState";
import { getValidationStepTypeText, ValidationStepType } from "@/dtos/validationStepType";
import { getZincCoatingText, ZincCoating } from "@/dtos/zincCoating";

@Component({
	components: {
		ArticleCadPreview,
		UpdateBoundingBoxCommand,
		PricelistButtonComponent,
	},
})
export default class ArticleComponent extends Vue {
	@Prop()
	private article!: ArticleDto;
	private loading: boolean = false;
	private recalculatingPrice: boolean = false;
	private updatingThumbnail: boolean = false;
	private simulateBendingRunning: boolean = false;
	private updateAssemblyRunning: boolean = false;
	private validateRunning: boolean = false;
	private deletingMessages: boolean = false;
	private designRunning: boolean = false;
	private camValidationRunning: boolean = false;
	private updateWeightRunning: boolean = false;
	private articleDialog: boolean = false;
	private lastSurcharge: number = 0;
	private lastBlexonComment: string = "";
	private lastManufacturingComment: string = "";
	private errorMessage: string = "";
	private articleFaces: IArticleFaceType[] = ArticleFaceTypes;
	private powderFinishes: IPowderFinish[] = PowderFinishes;
	private powderStructures: IPowderStructure[] = PowderStructures;
	private deleteMessagesDialog: boolean = false;
	private validationStateIconConfig: {} = {
		[ValidationStepState.Wait]: { icon: "access_time", color: "grey" },
		[ValidationStepState.Ready]: { icon: "play_circle", color: "grey" },
		[ValidationStepState.Running]: { icon: "directions_run", color: "blue" },
		[ValidationStepState.Successful]: { icon: "check_circle_outline", color: "green" },
		[ValidationStepState.Failed]: { icon: "close", color: "red" },
		[ValidationStepState.Blocked]: { icon: "dnd_forwardslash", color: "red" },
	};

	private mounted() {
		this.lastSurcharge = this.article.priceSurcharge;
		this.lastBlexonComment = this.article.blexonComment;
		this.lastManufacturingComment = this.article.manufacturingComment;
		this.article.camMessages.forEach((m: any) => (m.isSelected = true));
	}

	@Watch("deleteMessagesDialog")
	private onDeleteMessagesDialogChanged() {
		if (this.deleteMessagesDialog) {
			this.article.camMessages.forEach((m: any) => (m.isSelected = true));
		}
	}

	private get validationProgress() {
		return this.$store.state.validationProgresses.find(
			(a: any) => a.articleId == this.article.articleId
		);
	}

	private getValidationStepTypeText(type: ValidationStepType): string {
		return getValidationStepTypeText(type);
	}

	private get entgratarten() {
		return [
			{
				text: getEntgratartText(0),
				value: 0,
			},
			{
				text: getEntgratartText(2),
				value: 2,
			},
			{
				text: getEntgratartText(4),
				value: 4,
			},
			{
				text: getEntgratartText(3),
				value: 3,
			},
			{
				text: getEntgratartText(1),
				value: 1,
			},
		];
	}

	private get articleStateText() {
		switch (this.article.state) {
			case ArticleState.OK: {
				return "OK";
			}
			case ArticleState.Warning: {
				return "Warnung";
			}
			case ArticleState.Error: {
				return "Fehler";
			}
			case ArticleState.Locked: {
				return "Gesperrt";
			}
			case ArticleState.New: {
				return "Neu";
			}
			case ArticleState.Info: {
				return "Aktion erforderlich";
			}
			case ArticleState.Deleted: {
				return "Gelöscht";
			}
			default: {
				return "Unklar";
			}
		}
	}
	private get articleStateColor() {
		switch (this.article.state) {
			case ArticleState.OK: {
				return "#C8E6C9";
			}
			case ArticleState.Warning: {
				return "#FFF9C4";
			}
			case ArticleState.Error: {
				return "#FFCDD2";
			}
			case ArticleState.Locked: {
				return "#CFD8DC";
			}
			case ArticleState.Deleted: {
				return "#fdcdff";
			}
			default: {
				return "blue";
			}
		}
	}
	private async updateEntgratart() {
		try {
			this.loading = true;
			await httpClient().post(
				`Article/SetEntgratart?articleId=${this.article.articleId}&entgratart=${this.article.entgratart}`
			);
		} catch {
			console.log("Update entgratart failed.");
			this.$store.commit("setSnackbarErrorText", "Entgratart konnte nicht gesetzt werden.");
		} finally {
			this.loading = false;
		}
	}

	private async updateArticle() {
		try {
			this.loading = true;
			await httpClient().post(`Article/UpdateArticleData`, this.article);
			this.$store.commit("setSnackbarText", "Änderungen erfolgreich gespeichert.");
		} catch {
			console.log("Update article failed.");
			this.$store.commit("setSnackbarErrorText", "Fehler beim Speichern der Änderungen.");
		} finally {
			this.loading = false;
		}
	}

	private async deleteMessages() {
		try {
			this.deletingMessages = true;
			let messagesToDelete = this.getNonObsoleteCamMessages.filter((m: any) => m.isSelected);
			console.log(messagesToDelete);
			let response;
			if (messagesToDelete.length === this.getNonObsoleteCamMessages.length) {
				response = await httpClient().post(
					`Article/DeleteAllMessages?articleId=${this.article.articleId}`,
					null
				);
			} else {
				response = await httpClient().post(
					`Article/DeleteArticleMessages?articleId=${this.article.articleId}`,
					messagesToDelete
				);
			}
			this.$store.dispatch("updateArticle", this.article.articleId);
			this.$store.commit(
				"setSnackbarText",
				"Ausgewählte CAM und Blexon Meldungen erfolgreich gelöscht."
			);
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Löschen der Meldungen.");
		} finally {
			this.deletingMessages = false;
			this.deleteMessagesDialog = false;
		}
	}

	private async design() {
		try {
			this.designRunning = true;
			const response = await httpClient().post(
				`Article/design?articleId=${this.article.articleId}`
			);
			this.$store.commit("setSnackbarText", "Design für Artikel berechnet.");
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Design.");
		} finally {
			this.designRunning = false;
		}
	}

	private async camValidation() {
		try {
			this.camValidationRunning = true;
			const response = await httpClient().post(
				`Article/CamValidation?articleId=${this.article.articleId}`
			);
			this.$store.commit("setSnackbarText", "CAM Validation wurde gestartet.");
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Aufruf von CamValidation.");
		} finally {
			this.camValidationRunning = false;
		}
	}

	private async updatePrice() {
		try {
			this.recalculatingPrice = true;
			await httpClient().post(
				`Calculation/CalculateStaffelpreise?articleId=${this.article.articleId}`
			);
			this.$store.commit("setSnackbarText", "Preis wird neu berechnet.");
		} catch {
			console.log("Update bounding box failed.");
			this.$store.commit("setSnackbarErrorText", "Preisberechnung ist fehlgeschlagen.");
		} finally {
			this.recalculatingPrice = false;
		}
	}

	private async updateThumbnail() {
		try {
			this.updatingThumbnail = true;
			await httpClient().post(`Article/UpdateThumbnail?articleId=${this.article.articleId}`);
			this.$store.commit("setSnackbarText", "Vorschaubild wird neu berechnet");
		} catch {
			console.log("Update thumbnail failed.");
			this.$store.commit("setSnackbarErrorText", "Update Thumbnail ist fehlgeschlagen.");
		} finally {
			this.updatingThumbnail = false;
		}
	}

	private async updateWeight() {
		try {
			this.updateWeightRunning = true;
			const response = await httpClient().post(
				`Article/UpdateArticleWeight?articleId=${this.article.articleId}`
			);
			this.article.weight = response.data.weight;
			this.$store.commit(
				"setSnackbarText",
				"Gewicht erfolgreich neu berechnet und gespeichert."
			);
		} catch {
			console.log("Update weight failed.");
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler bei der Neuberechnung des Gewichts."
			);
		} finally {
			this.updateWeightRunning = false;
		}
	}

	private async simulateBending() {
		try {
			this.simulateBendingRunning = true;
			const response = await httpClient().post(
				`Article/simulateBending?articleId=${this.article.articleId}`
			);
			this.$store.commit("setSnackbarText", "Biegesimulation durchgeführt.");
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Aufruf der Biegesimulation.");
		} finally {
			this.simulateBendingRunning = false;
		}
	}

	private async updateAssembly() {
		try {
			this.updateAssemblyRunning = true;
			const response = await httpClient().post(
				`Article/updateBaugruppe?subarticleId=${this.article.articleId}`
			);
			this.$store.commit("setSnackbarText", "Baugruppe wurde aktualisiert.");
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Aktualisieren der Baugruppe.");
		} finally {
			this.updateAssemblyRunning = false;
		}
	}

	private async validate() {
		try {
			this.validateRunning = true;
			const response = await httpClient().post(
				`Article/validate?articleId=${this.article.articleId}`
			);
			this.$store.commit(
				"setSnackbarText",
				"Validation gestartet. Der Artikel wird selbständig aktualisiert."
			);
		} catch {
			this.$store.commit("setSnackbarErrorText", "Fehler beim Start der Validation.");
		} finally {
			this.validateRunning = false;
		}
	}

	private async lockArticle() {
		try {
			await httpClient().post(`article/LockArticle?articleId=${this.article.articleId}`);
			this.$store.commit("setSnackbarText", "Artikel erfolgreich gesperrt.");
		} catch (err) {
			console.log(`Der Artikel konnte nicht gesperrt werden. Error: ${err}`);
		}
	}

	private async unlockArticle() {
		try {
			const response = await httpClient().post(
				`article/UnlockArticle?articleId=${this.article.articleId}`
			);
			this.article.state = response.data;
		} catch (err) {
			console.log(`Der Artikel konnte nicht entsperrt werden. Error: ${err}`);
		}
	}

	private async downloadOriginalImportFile() {
		this.$store.dispatch("downloadOriginalImportFile", this.article.articleId);
	}

	private async deleteArticle() {
		try {
			if (window.confirm("Sicher?")) {
				await httpClient().post(`article/delete?articleId=${this.article.articleId}`);
				// Event um den Artikel auch lokal zu löschen
				this.$emit("deleted", this.article.articleId);
			}
		} catch (err) {
			console.error(`Der Artikel konnte nicht gelöscht werden. Error: ${err}`);
		}
	}

	private async changeOverrideCanBeHung() {
		try {
			await httpClient().post(
				`article/SetCanBeHungOverride?articleId=${this.article.articleId}&overrideEnabled=${this.article.canBeHungOverride}`,
				null
			);
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderung konnten nicht gespeichert werden."
			);
		}
	}

	private async reactivateArticle() {
		if (this.article.state != ArticleState.Deleted) return;
		try {
			this.article.calculating = true;
			await httpClient().post(
				`article/ReactivateArticle?articleId=${this.article.articleId}`,
				null
			);
			this.$store.commit("setSnackbarText", "Artikel erfolgreich reaktiviert.");
			this.$emit("reactivatedArticle", this.article.articleId);
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Artikel konnte nicht reaktiviert werden.");
		}
	}

	private async saveEdits() {
		if (this.article.priceSurcharge == null || (this.article.priceSurcharge as any) == "") {
			this.article.priceSurcharge = 0;
		}
		try {
			if (this.lastBlexonComment != this.article.blexonComment) {
				let data: any = {
					comment: this.article.blexonComment,
				};
				await httpClient().post(
					`article/SetBlexonComment?articleId=${this.article.articleId}`,
					data
				);
				this.lastBlexonComment = this.article.blexonComment;
			}
			if (this.lastManufacturingComment != this.article.manufacturingComment) {
				let data: any = {
					comment: this.article.manufacturingComment,
				};
				await httpClient().post(
					`article/SetManufacturingComment?articleId=${this.article.articleId}`,
					data
				);
				this.lastManufacturingComment = this.article.manufacturingComment;
			}
			if (this.lastSurcharge != this.article.priceSurcharge) {
				let data: any = {
					surcharge: this.article.priceSurcharge,
				};
				await httpClient().post(
					`article/SetSurcharge?articleId=${this.article.articleId}`,
					data
				);
				this.lastSurcharge = this.article.priceSurcharge;
			}
			if (this.errorMessage != "") {
				let data: any = {
					comment: this.errorMessage,
				};
				await httpClient().post(
					`article/addHelpdeskMessage?articleId=${this.article.articleId}`,
					data
				);
				this.errorMessage = "";
			}
			// Remove existing price lists so that they're fetched again when requested.
			// Also remove prices for the assembly if this is a subarticle.
			let articleIdsToRemovePricesFor = [this.article.articleId];
			if (this.article.parentArticleId && this.article.parentArticleId > 0) {
				console.log("This article is part of an assembly...");
				articleIdsToRemovePricesFor.push(this.article.parentArticleId);
			}
			this.$store.commit("removeArticlePriceLists", articleIdsToRemovePricesFor);
			this.$store.commit("setSnackbarText", "Änderungen wurden erfolgreich gespeichert.");
		} catch (err) {
			this.$store.commit(
				"setSnackbarErrorText",
				"Änderungen konnten nicht korrekt gespeichert werden."
			);
		} finally {
			this.articleDialog = false;
		}
	}

	private GetArticleFaceString(enumValue: number) {
		return this.articleFaces.filter((type: IArticleFaceType) => type.value == enumValue)[0]
			.text;
	}
	private GetStructureString(enumValue: number) {
		return this.powderStructures.filter((type: IPowderStructure) => type.value == enumValue)[0]
			.text;
	}
	private GetFinishString(enumValue: number) {
		return this.powderFinishes.filter((type: IPowderFinish) => type.value == enumValue)[0].text;
	}

	private getFeatureString(article: ArticleDto): string {
		let featureTexts: string[] = [];
		const featureDtoTexts = article.featureDtos.map((f) => `${f.count} * ${f.formVorlageText}`);
		featureTexts.push(...featureDtoTexts);
		if (article.hasEngravings) {
			featureTexts.push("Gravur");
		}
		return featureTexts.join(" | ");
	}

	private priceListsUpdated(priceLists: PriceListDto[] | null) {
		if (priceLists !== null) {
			this.article.priceLists = priceLists;
		}
	}

	/**
	 * Creates a text to show at the user interface to inform the user
	 * about the weldline features.
	 */
	private getWeldlineString(): string {
		return ArticleHelper.getWeldlineString(this.article);
	}

	private get getNonObsoleteCamMessages() {
		return this.article.camMessages.filter((m: any) => m.state === 0);
	}

	private getMessageSchweregradText(schweregrad: number) {
		switch (schweregrad) {
			case 0:
				return "Info";
			case 1:
				return "Warnung";
			case 2:
				return "Error";
			default:
				return "Unbekannter Nachrichtentyp";
		}
	}

	private get zincCoatingText(): string {
		return getZincCoatingText(this.article.zincCoating);
	}
}
